import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const RECENT_DOCUMENTS_SEARCH_RESULTS_SCHEMA = Object.freeze({
  RESULTS: List<any>(),
});
const RECORD = generateSchema(RECENT_DOCUMENTS_SEARCH_RESULTS_SCHEMA);
const KEYS: any = generateKeys(RECENT_DOCUMENTS_SEARCH_RESULTS_SCHEMA);

export class RecentDocumentsSearchResults extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get results(): List<any> {
    return this.get(KEYS.RESULTS);
  }

  get totalMatches(): number {
    return (this.results && this.results.size) || 0;
  }
}
